import styled from 'styled-components';

import { device } from 'theme/media';

import {
  Card,
  Header2
} from 'theme/mixins';
export * from 'theme/mixins';

export const Wrapper = styled.div`
  display: flex;
  width: inherit;
  flex-direction: column;
`;

export const StyledCard = styled(Card)`
  margin: 5rem auto 5rem auto;

  @media ${device.mobile} {
    width: 100%;
  }

  @media ${device.mobileL} {
    width: 40rem;
  }

  @media ${device.tablet} {
    width: 50rem;
  }
`;

export const StyledHeader = styled(Header2)`
  margin-top: 0;
  border: none;
`;

